import sortBy from 'lodash/sortBy'
import { useEffect, useState } from 'react'

import { useVatDeclaration } from '@features/vatDeclarations/hooks/useVatDeclaration'
import { VatDeclarationsPeriod } from '@features/vatDeclarations/types/vatDeclarationsPeriod'
import { getDaysPastDeadline } from '@features/vatDeclarations/utils/getDaysPastDeadline'

import { TaxReturn } from '../../../../../types/taxReturn'
import { useFetchVatDeclarations } from '../../../../vatDeclarations/hooks/useFetchVatDeclarations'

interface UseVatPeriod {
  isError?: boolean
  isLoading?: boolean
  vatDeclaration?: VatDeclarationsPeriod
  vatReturnPeriod?: TaxReturn
}

const MAX_NUMBER_DUE_DAYS = 20

export const useVatPeriod = (): UseVatPeriod => {
  const [vatReturnPeriod, setVatReturnPeriod] = useState<TaxReturn>()

  const {
    data: vatDeclarations,
    isLoading: areVatDeclarationsLoading,
    isError: isVatDeclarationsError,
  } = useFetchVatDeclarations()

  const {
    vatDeclaration,
    isLoading: isPeriodLoading,
    isError: isPeriodError,
  } = useVatDeclaration({ vatDeclarationId: vatReturnPeriod?.id })

  useEffect(() => {
    const canPeriodBeSettled = (period: TaxReturn): boolean =>
      !period.isSettled && getDaysPastDeadline(period.reportDeadline) <= MAX_NUMBER_DUE_DAYS

    const findTaxReturnPeriodToDisplay = (periods: TaxReturn[]) => {
      const periodsThatCanBeSettled = periods.filter(canPeriodBeSettled)
      const periodsThatCanBeSettledSortedByDate = sortBy(periodsThatCanBeSettled, 'reportDeadline')
      setVatReturnPeriod(periodsThatCanBeSettledSortedByDate[0])
    }

    if (vatDeclarations) {
      findTaxReturnPeriodToDisplay(vatDeclarations)
    }
  }, [vatDeclarations])

  const isLoading = areVatDeclarationsLoading || isPeriodLoading
  const isError = isVatDeclarationsError || isPeriodError

  return { isLoading, isError, vatDeclaration, vatReturnPeriod }
}
